/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import { ORIGINAL_VIDEO_LANGUAGE_OPTIONS } from '@src/config/languages';
import { useTopicFilter } from '@src/hooks/useTopicFilter';
import { useStore } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import CheckIconAlt from '@src/svgs/CheckIconAlt';
import CreateIcon from '@src/svgs/CreateIcon';
import InfoIconAlt from '@src/svgs/InfoIconAlt';
import {
  buildSpeakersFromMappings,
  extractSpeakerLabelsFromTranscriptElements,
  fetchDatoSpeakers,
  fetchSpeakerVoiceMappings,
} from '@src/utility/speakerUtils';
import { getThemeTooltip } from '@src/utility/themeTooltips';
import { useFlagsCombination } from '@src/utility/useFlagsCombination';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import styled, { css } from 'styled-components';

import { parseClipThemeTitles } from '../../utility/story';
import AudienceFilterComponent from '../common/AudienceFilterComponent';
import AutoResizeableMultilineInput from '../common/AutoResizeableMultilineInput';
import GoalFilterComponent from '../common/GoalFilterComponent';
import ItemDropdownSelect from '../common/ItemDropdownSelect';
import Modal from '../common/Modal';
import PhotoSourceFilterComponent, {
  type PhotoSourceSelection,
} from '../common/PhotoSourceFilterComponent';
import SpeakerFilterComponent from '../common/SpeakerFilterComponent';
import Switch from '../common/Switch';
import TopicFilterDropdown from '../common/TopicFilterDropdown';
import { useOutsideAlerter } from '../transcript/useClickOutside';

import type { AudienceOption } from '../common/AudienceSelector';
import type { GoalOption } from '../common/GoalSelector';
import type { Speaker } from './SpeakerTypes';
import type { AIPrompt } from '@src/types.ts/ai_prompts';

const THEME_PLACEHOLDER_EXAMPLES: Record<string, string> = {
  Quotes: 'Highlight moments of personal reflection and vulnerability',
  Blog: 'Emphasize data-driven insights and industry trends',
  'Social Post': 'Make it punchy and shareable with a strong hook',
  Email: 'Use a warm, conversational tone with a clear call to action',
};

function getThemePlaceholder(themeTitle: string, customType?: string): string {
  const example =
    THEME_PLACEHOLDER_EXAMPLES[customType ?? ''] ??
    'Focus on leadership challenges and growth moments';
  return `Refine "${themeTitle}" (e.g., '${example}')`;
}

type Props = {
  title: string;
  templatesHeading?: string;
  templatesSublabel?: string;
  templates: AIPrompt[];
  allowBrandVoice?: boolean;
  customType?: 'Blog' | 'Social Post' | 'Email' | 'Quotes';
  customInstructionsLabel?: string;
  onClose: () => void;
  onConfirm: (
    template?: AIPrompt,
    brandVoice?: string,
    customInstructions?: string,
    avoidWords?: string,
    selectedSpeakers?: Speaker[],
    selectedGoal?: GoalOption | null,
    selectedAudiences?: AudienceOption[],
    selectedLanguage?: string,
    selectedPhotoSources?: PhotoSourceSelection,
    clipTranscript?: string,
    speakerFilterActive?: boolean,
    selectedTopics?: string[],
  ) => void;
  confirmButtonLabel?: string;
  // Flag to enable speaker selection for pull quotes
  enableSpeakerSelection?: boolean;
  // Flag to enable photo source selection for pull quotes
  enablePhotoSourceSelection?: boolean;
};

function AIProducerModal(props: Props) {
  const {
    title,
    templates,
    allowBrandVoice = true,
    customType,
    customInstructionsLabel = 'Customize your prompt',
    onClose,
    onConfirm,
    confirmButtonLabel = 'Generate',
    enableSpeakerSelection = false,
    enablePhotoSourceSelection = false,
  } = props;

  const { userIdentityStore } = useStore();
  const videoCreator = useVideoCreatorStore();
  const flags = useFlagsCombination(
    userIdentityStore.currentIdentity?.role as any,
  );

  // Check if transcript editor is enabled
  const isTranscriptEditorEnabled = flags.enableTranscriptEditor;
  const isAIContentLanguageSelectionEnabled =
    flags.contentStudioEnableAIContentLanguageSelection;
  const isCustomAiEnabled = flags.contentStudioAiEnableCustom;

  // Clip transcript selection state
  const clipsWithTranscript =
    customType === 'Social Post' ||
    customType === 'Quotes' ||
    customType === 'Blog' ||
    customType === 'Email'
      ? (videoCreator.story?.otherVideos ?? []).filter(
          v => !!v.transcriptionText,
        )
      : [];
  const [useClipTranscript, setUseClipTranscript] = useState(false);
  const [selectedClipId, setSelectedClipId] = useState<string | null>(null);
  const selectedClip = clipsWithTranscript.find(c => c.id === selectedClipId);
  const [sourceDropdownOpen, setSourceDropdownOpen] = useState(false);
  const sourceDropdownRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(sourceDropdownRef, () => setSourceDropdownOpen(false));

  const brandVoice = videoCreator.organization?.branding?.brandVoice;
  const avoidWords = videoCreator.organization?.branding?.avoidWords;
  const goals = videoCreator.organization?.branding?.goals || [];
  const audiences = videoCreator.organization?.branding?.audiences || [];
  const [selectedTemplate, setSelectedTemplate] = useState<AIPrompt | null>(
    null,
  );
  const [selectedGoal, setSelectedGoal] = useState<GoalOption | null>(null);
  const [useGoalFilter, setUseGoalFilter] = useState(false);
  const [selectedAudiences, setSelectedAudiences] = useState<AudienceOption[]>(
    [],
  );
  const [useAudienceFilter, setUseAudienceFilter] = useState(false);

  // Validation state
  const [themeError, setThemeError] = useState<string | null>(null);
  const themeSectionRef = useRef<HTMLDivElement>(null);
  const [useCustomPrompt, setUseCustomPrompt] = useState(false);

  const handleSelectTemplate = (template: AIPrompt) => {
    setSelectedTemplate(prev => (prev?.id === template.id ? null : template));
    setThemeError(null);
  };

  const [shouldUseBrandVoice, setShouldUseBrandVoice] = useState(!!brandVoice);
  const [customInstructions, setCustomInstructions] = useState('');
  const handleChangeCustomInstructions = useCallback((value: string) => {
    setCustomInstructions(value);
    if (value) setThemeError(null);
  }, []);

  const storyTopics = useMemo(
    () => parseClipThemeTitles(videoCreator.story?.clipThemesJson),
    [videoCreator.story?.clipThemesJson],
  );

  const { selectedTopics, handleTopicsApply } = useTopicFilter(
    customInstructions,
    setCustomInstructions,
  );

  // Speaker selection related state
  const [speakers, setSpeakers] = useState<Speaker[]>([]);
  const [selectedSpeakers, setSelectedSpeakers] = useState<Speaker[]>([]);
  const [isLoadingSpeakers, setIsLoadingSpeakers] = useState(false);
  const [useSpeakerFilter, setUseSpeakerFilter] = useState(false);
  const [useLanguageSelection, setUseLanguageSelection] = useState(false);
  const [language, setLanguage] = useState(
    videoCreator.rootStore?.transcriptionStore.language,
  );

  // Photo source selection state
  const [selectedPhotoSources, setSelectedPhotoSources] =
    useState<PhotoSourceSelection>({
      brandKit: true,
      story: true,
    });

  // Load speaker data when component mounts - only if transcript editor is enabled
  useEffect(() => {
    // Skip loading speakers if:
    // - speaker selection is disabled,
    // - no story ID,
    // - or transcript editor feature is disabled via LaunchDarkly flag
    if (
      !enableSpeakerSelection ||
      !videoCreator.story?.id ||
      !isTranscriptEditorEnabled
    )
      return;

    const loadSpeakers = async () => {
      setIsLoadingSpeakers(true);
      try {
        // Extract speaker labels from transcript
        const transcriptElements =
          videoCreator.rootStore?.transcriptionStore?.getFinalTranscriptionElements();
        const speakerLabels =
          extractSpeakerLabelsFromTranscriptElements(transcriptElements);

        if (speakerLabels.length === 0) {
          // No speakers found in transcript
          setIsLoadingSpeakers(false);
          return;
        }

        // Fetch mappings and Dato speakers
        const [speakerMappings, datoSpeakers] = await Promise.all([
          fetchSpeakerVoiceMappings(videoCreator.story!.id),
          fetchDatoSpeakers(
            videoCreator.story!.id,
            videoCreator.datoClientStore,
          ),
        ]);

        // Build the complete speaker list
        const speakerList = buildSpeakersFromMappings(
          speakerLabels,
          speakerMappings,
          datoSpeakers,
        );

        setSpeakers(speakerList);
        // Default to selecting all speakers
        setSelectedSpeakers(speakerList);
      } catch (error) {
        console.error('Error loading speaker data:', error);
      } finally {
        setIsLoadingSpeakers(false);
      }
    };

    loadSpeakers();
  }, [
    videoCreator.story?.id,
    enableSpeakerSelection,
    isTranscriptEditorEnabled,
  ]);

  const handleConfirm = () => {
    // Validate required fields
    const hasTheme = useCustomPrompt
      ? !!customInstructions
      : !!selectedTemplate;
    if (!hasTheme) {
      setThemeError(
        useCustomPrompt
          ? 'Please describe your prompt to continue'
          : 'Please select a prompt to continue',
      );
      themeSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      return;
    }

    onClose();

    onConfirm(
      selectedTemplate ?? undefined,
      allowBrandVoice && shouldUseBrandVoice ? brandVoice : undefined,
      (customType && isCustomAiEnabled && customInstructions) || undefined,
      avoidWords,
      // Include speaker labels if filtering is in use (for any content type)
      // if quote and no speaker filter selected - pass all if them
      useSpeakerFilter
        ? selectedSpeakers
        : customType === 'Quotes'
          ? speakers
          : undefined,
      useGoalFilter ? selectedGoal : undefined,
      useAudienceFilter && selectedAudiences.length > 0
        ? selectedAudiences
        : undefined,
      language,
      enablePhotoSourceSelection ? selectedPhotoSources : undefined,
      useClipTranscript && selectedClip?.transcriptionText
        ? selectedClip.transcriptionText
        : undefined,
      useSpeakerFilter,
      selectedTopics,
    );
  };

  return (
    <Modal
      isOpen
      closeModal={onClose}
      contentStyle={{
        marginTop: '40px',
        marginBottom: '40px',
      }}
    >
      <Wrapper data-testid="ai-producer-modal">
        <ScrollArea>
          <Content>
            <Title>{title}</Title>
            {/* Source selection: Full Story or a specific clip */}
            {clipsWithTranscript.length > 0 && (
              <Section>
                <SectionSublabel>Source</SectionSublabel>
                <SourceDropdown ref={sourceDropdownRef}>
                  <SourceSelected
                    onClick={() => setSourceDropdownOpen(!sourceDropdownOpen)}
                  >
                    <SourceSelectedText>
                      {useClipTranscript && selectedClip
                        ? selectedClip.title
                        : videoCreator.story?.title || 'Full Story'}
                    </SourceSelectedText>
                    <SourceBadge type={useClipTranscript ? 'clip' : 'story'}>
                      {useClipTranscript ? 'Clip' : 'Full Video'}
                    </SourceBadge>
                    <SourceArrow>
                      <svg
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                      >
                        <path
                          d="M2 4.33008L6 8.33008L10 4.33008"
                          stroke="var(--accent)"
                        />
                      </svg>
                    </SourceArrow>
                  </SourceSelected>
                  {sourceDropdownOpen && (
                    <SourceOptions>
                      <SourceOption
                        onClick={() => {
                          setUseClipTranscript(false);
                          setSelectedClipId(null);
                          setSourceDropdownOpen(false);
                        }}
                      >
                        <SourceOptionText>
                          {videoCreator.story?.title || 'Full Story'}
                        </SourceOptionText>
                        <SourceBadge type="story">Full Video</SourceBadge>
                      </SourceOption>
                      {clipsWithTranscript.map(clip => (
                        <SourceOption
                          key={clip.id}
                          onClick={() => {
                            setUseClipTranscript(true);
                            setSelectedClipId(clip.id ?? null);
                            setSourceDropdownOpen(false);
                          }}
                        >
                          <SourceOptionText>{clip.title}</SourceOptionText>
                          <SourceBadge type="clip">Clip</SourceBadge>
                        </SourceOption>
                      ))}
                    </SourceOptions>
                  )}
                </SourceDropdown>
              </Section>
            )}

            <Section ref={themeSectionRef} hasError={!!themeError}>
              {(!useCustomPrompt || storyTopics.length > 0) && (
                <ThemeHeaderRow>
                  {!useCustomPrompt ? (
                    <SectionSublabel>
                      Select your prompt <RequiredMark>*</RequiredMark>
                    </SectionSublabel>
                  ) : (
                    <ThemeHeaderSpacer />
                  )}
                  {storyTopics.length > 0 && (
                    <TopicFilterDropdown
                      topics={storyTopics}
                      selectedTopics={selectedTopics}
                      onApply={handleTopicsApply}
                    />
                  )}
                </ThemeHeaderRow>
              )}
              {!useCustomPrompt && (
                <>
                  <OptionList data-testid="ai-producer-theme-selector">
                    {templates.map(template => {
                      const isSelected = selectedTemplate?.id === template.id;
                      return (
                        <OptionItem
                          key={template.id}
                          selected={isSelected}
                          onClick={() => handleSelectTemplate(template)}
                        >
                          <div
                            className={`radioIndicator${isSelected ? ' selected' : ''}`}
                          >
                            {isSelected && <div className="radioDot" />}
                          </div>
                          <div className="optionLabel">
                            {template.title}
                            <ThemeInfoIcon
                              data-tooltip-id="theme-tooltip"
                              data-tooltip-content={getThemeTooltip(
                                template.title,
                                template.userPromptDescription,
                              )}
                              onClick={e => e.stopPropagation()}
                            >
                              <InfoIconAlt width="10" height="10" />
                            </ThemeInfoIcon>
                          </div>
                        </OptionItem>
                      );
                    })}
                  </OptionList>
                  {selectedTemplate && (
                    <CustomizeThemeSection>
                      <CustomizeThemeLabel>
                        {customInstructionsLabel}
                      </CustomizeThemeLabel>
                      <TextareaHoverWrapper>
                        <AutoResizeableMultilineInput
                          disableAutoResize
                          width="100%"
                          fontSize="12px"
                          placeholder={getThemePlaceholder(
                            selectedTemplate.title,
                            customType,
                          )}
                          value={customInstructions}
                          getValue={handleChangeCustomInstructions}
                          customStyles={
                            customInstructions
                              ? { borderColor: 'var(--accent)' }
                              : undefined
                          }
                        />
                      </TextareaHoverWrapper>
                    </CustomizeThemeSection>
                  )}
                </>
              )}
              {!!customType && isCustomAiEnabled && (
                <CustomPromptSection
                  onClick={() => {
                    const next = !useCustomPrompt;
                    setUseCustomPrompt(next);
                    if (next) {
                      setSelectedTemplate(null);
                      setCustomInstructions('');
                    } else {
                      setCustomInstructions('');
                    }
                    setThemeError(null);
                  }}
                >
                  <CustomPromptHeader>
                    <CustomPromptLabel>
                      <CustomPromptIcon>✦</CustomPromptIcon>
                      <CustomPromptText>
                        <CustomPromptTitle>
                          Describe your own prompt
                          {useCustomPrompt && <RequiredMark>*</RequiredMark>}
                        </CustomPromptTitle>
                      </CustomPromptText>
                    </CustomPromptLabel>
                    <Switch
                      label=""
                      checked={useCustomPrompt}
                      onClick={e => {
                        e.stopPropagation();
                        const next = !useCustomPrompt;
                        setUseCustomPrompt(next);
                        if (next) {
                          setSelectedTemplate(null);
                          setCustomInstructions('');
                        } else {
                          setCustomInstructions('');
                        }
                        setThemeError(null);
                      }}
                      small
                    />
                  </CustomPromptHeader>
                  {useCustomPrompt && (
                    <CustomPromptTextarea
                      onClick={e => e.stopPropagation()}
                      placeholder="Describe exactly what you're looking for (e.g., 'Key insights about market trends and competitive landscape')"
                      value={customInstructions}
                      onChange={e => {
                        handleChangeCustomInstructions(e.target.value);
                      }}
                      autoFocus
                    />
                  )}
                </CustomPromptSection>
              )}
              {themeError && (
                <ValidationErrorMessage>{themeError}</ValidationErrorMessage>
              )}
            </Section>

            <CompactSections>
              {/* Goal selection */}
              {goals.length > 0 && (
                <GoalFilterComponent
                  goals={goals}
                  align="left"
                  selectedGoal={selectedGoal}
                  setSelectedGoal={setSelectedGoal}
                  useGoalFilter={useGoalFilter}
                  setUseGoalFilter={setUseGoalFilter}
                  allowNone
                />
              )}

              {/* Audience selection */}
              {audiences.length > 0 && (
                <AudienceFilterComponent
                  align="left"
                  audiences={audiences}
                  selectedAudiences={selectedAudiences}
                  setSelectedAudiences={setSelectedAudiences}
                  useAudienceFilter={useAudienceFilter}
                  setUseAudienceFilter={setUseAudienceFilter}
                />
              )}

              {/* Speaker selection for all supported content types - only show if transcript editor is enabled */}
              {isTranscriptEditorEnabled && speakers.length > 0 && (
                <div data-testid="articles-speaker-selector">
                  <SpeakerFilterComponent
                    speakers={speakers}
                    selectedSpeakers={selectedSpeakers}
                    setSelectedSpeakers={setSelectedSpeakers}
                    useSpeakerFilter={useSpeakerFilter}
                    setUseSpeakerFilter={setUseSpeakerFilter}
                    isLoadingSpeakers={isLoadingSpeakers}
                    title="Filter by Speaker"
                    align="left"
                    infoText=""
                  />
                </div>
              )}

              {/* Photo source selection for quotes */}
              {enablePhotoSourceSelection && (
                <PhotoSourceFilterComponent
                  selectedSources={selectedPhotoSources}
                  setSelectedSources={setSelectedPhotoSources}
                  align="left"
                />
              )}

              {/* Brand voice option */}
              {allowBrandVoice ? (
                <>
                  <CheckBoxContainer
                    align={'left'}
                    onClick={
                      brandVoice
                        ? () => setShouldUseBrandVoice(cur => !cur)
                        : undefined
                    }
                    disabled={!brandVoice}
                    data-tooltip-id="brand-voice-tooltip"
                    data-tooltip-content={
                      brandVoice
                        ? undefined
                        : 'Add your brand voice on the Brand Kit page'
                    }
                  >
                    <CheckBox isChecked={shouldUseBrandVoice} role="button">
                      {shouldUseBrandVoice && <CheckIconAlt />}
                    </CheckBox>
                    <div className="checkbox-text">Use my Brand Voice</div>
                  </CheckBoxContainer>
                  <Tooltip
                    id="brand-voice-tooltip"
                    style={{
                      width: '150px',
                      color: 'var(--text-secondary)',
                      textAlign: 'center',
                      padding: '8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      lineHeight: '120%',
                      zIndex: '10',
                    }}
                  />
                </>
              ) : null}

              {isAIContentLanguageSelectionEnabled && (
                <CheckBoxContainer
                  align={'left'}
                  onClick={() => setUseLanguageSelection(cur => !cur)}
                >
                  <CheckBox isChecked={useLanguageSelection} role="button">
                    {useLanguageSelection && <CheckIconAlt />}
                  </CheckBox>
                  <div className="checkbox-text">Select Language</div>
                </CheckBoxContainer>
              )}

              {useLanguageSelection && (
                <DropdownWrapper>
                  <ItemDropdownSelect
                    action={(_, value) => value && setLanguage(value)}
                    propertyName="contentLanguage"
                    defaultValue={language}
                    values={ORIGINAL_VIDEO_LANGUAGE_OPTIONS}
                  />
                </DropdownWrapper>
              )}
            </CompactSections>
          </Content>
        </ScrollArea>

        <Tooltip
          id="theme-tooltip"
          noArrow
          opacity={1}
          style={{
            maxWidth: '240px',
            backgroundColor: 'var(--popover)',
            color: 'var(--popover-foreground)',
            fontSize: 'var(--text-xs)',
            fontWeight: 'var(--font-weight-medium)',
            border: '1px solid var(--border-subtle)',
            borderRadius: '6px',
            boxShadow: 'var(--elevation-sm)',
            padding: '5px 10px',
            zIndex: '1000003',
            lineHeight: '1.4',
          }}
          offset={12}
        />

        <Footer>
          <WriteButton
            data-testid="ai-producer-generate-button"
            onClick={handleConfirm}
          >
            <CreateIcon width="16" height="16" />
            {confirmButtonLabel}
          </WriteButton>
        </Footer>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  border-radius: 10px;
  background-color: var(--surface-subtle);
  width: 100%;
  max-width: 942px;
  min-width: 825px;
  border: 1px solid var(--border);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
`;

const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  min-height: 0;
`;

const Content = styled.div`
  max-width: 580px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 0 24px 48px;
`;

const Footer = styled.div`
  padding: 24px 0 16px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  position: relative;

  /* Gradient fade above the button to indicate scrollability */
  &::before {
    content: '';
    position: absolute;
    top: -40px;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      var(--surface-subtle) 100%
    );
    pointer-events: none;
  }
`;

const Title = styled.h2`
  margin: 0;
  padding-top: 40px;
  padding-bottom: 24px;
  color: var(--foreground);
  text-align: center;
  font-size: 32px;
  font-weight: 700;
`;

const CompactSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Section = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid var(--destructive);
      border-radius: 8px;
      padding: 12px;
    `}
`;

const SectionSublabel = styled.div`
  color: var(--foreground);
  font-size: 12px;
  line-height: 140%;
`;

const ThemeHeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const ThemeHeaderSpacer = styled.div`
  flex: 1;
`;

const OptionList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;

const OptionItem = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background-color: var(--surface);
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover ${() => ThemeInfoIcon} {
    opacity: 1;
  }
  &:hover {
    background-color: var(--surface-elevated);
    border-color: var(--border);
  }
  .optionLabel {
    color: var(--foreground);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    flex: 1;
  }
  .radioIndicator {
    width: 14px;
    height: 14px;
    border-radius: 14px;
    border: 1px solid var(--text-muted);
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  .radioIndicator.selected {
    border-color: var(--accent);
    background: var(--background);
  }
  .radioDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--accent);
  }
`;

const ThemeInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 4px;
  vertical-align: middle;
  opacity: 0;
  transition:
    opacity 0.15s ease,
    color 0.15s ease;

  &:hover {
    color: inherit;
  }
`;

const CheckBoxContainer = styled.div<{
  disabled?: boolean;
  align?: 'center' | 'left';
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 8px;
  cursor: pointer;
  &,
  * {
    box-sizing: border-box;
  }
  .checkbox-text {
    color: var(--foreground);
    font-size: 12px;
    line-height: 140%;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  outline: 0;
  background-color: ${props =>
    props.isChecked ? 'var(--accent)' : 'transparent'};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid
    ${props => (props.isChecked ? 'var(--accent)' : 'var(--text-muted)')};
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WriteButton = styled.button`
  width: 240px;
  display: flex;
  height: 48px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: var(--primary);
  border-radius: 8px;
  border: none;
  outline: none;
  cursor: pointer;
  color: var(--background);
  font-size: 14px;
  font-weight: 700;
  transition: 0.15s;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const DropdownWrapper = styled.div`
  color: var(--foreground);
  .Selected {
    padding: 8px 10px;
  }
  .Options span {
    padding: 8px 10px;
  }
  .Options span:first-child {
    color: var(--text-muted);
  }
`;

const TextareaHoverWrapper = styled.div`
  textarea {
    transition: border-color 150ms ease;
    color: var(--foreground);
    background-color: var(--surface);
    border-radius: 8px;
  }
`;

const SourceDropdown = styled.div`
  position: relative;
`;

const SourceSelected = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--surface);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--foreground);
  transition:
    border-color 150ms ease,
    background-color 150ms ease;

  &:hover {
    background-color: var(--surface-elevated);
  }
`;

const SourceSelectedText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SourceArrow = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const SourceOptions = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--surface);
  box-shadow: var(--elevation-toast);
  max-height: 200px;
  overflow-y: auto;
  z-index: 3;
  scrollbar-width: thin;
`;

const SourceOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--foreground);
  transition: background-color 150ms ease;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border);
  }
  &:hover {
    background-color: rgba(242, 208, 147, 0.08);
  }
  &:first-child {
    border-radius: 8px 8px 0 0;
  }
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
  &:only-child {
    border-radius: 8px;
  }
`;

const SourceOptionText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SourceBadge = styled.span<{ type: 'story' | 'clip' }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: 999px;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-text-xs);
  white-space: nowrap;
  background-color: ${({ type }) =>
    type === 'story' ? 'var(--badge-green-bg)' : 'var(--badge-yellow-bg)'};
  color: ${({ type }) =>
    type === 'story' ? 'var(--badge-green-text)' : 'var(--badge-yellow-text)'};
`;

const RequiredMark = styled.span`
  color: var(--destructive);
  margin-left: 2px;
`;

const ValidationErrorMessage = styled.div`
  color: var(--destructive);
  padding: 8px 12px;
  background-color: rgba(255, 107, 107, 0.1);
  border-radius: 8px;
  font-size: 12px;
`;

const CustomizeThemeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CustomizeThemeLabel = styled.div`
  color: var(--foreground);
  font-size: 12px;
  font-weight: 500;
  line-height: 140%;
`;

const CustomPromptSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background-color: var(--surface);
  box-sizing: border-box;
  cursor: pointer;
  transition: 150ms;
`;

const CustomPromptHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const CustomPromptLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CustomPromptIcon = styled.span`
  color: var(--primary);
  font-size: 14px;
  flex-shrink: 0;
`;

const CustomPromptText = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomPromptTitle = styled.span`
  color: var(--foreground);
  font-size: 12px;
  font-weight: 600;
  line-height: 140%;
`;

const CustomPromptTextarea = styled.textarea`
  box-sizing: border-box;
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid var(--border);
  font-family: 'Inter', sans-serif;
  text-align: left;
  font-size: 12px;
  line-height: 150%;
  background-color: var(--surface-subtle);
  color: var(--foreground);
  width: 100%;
  resize: none;
  height: 70px;
  outline: none;
  &::placeholder {
    color: var(--text-muted);
  }
`;

export default AIProducerModal;
